import React from "react";
import styles from "./EULA.module.css"; // optional CSS Module

const EULA = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>END USER LICENSE AGREEMENT (EULA)</h1>

      <p>
        This End User License Agreement (“Agreement”) is a legal agreement
        between you (“User” or “You”) and Charles Technologies Private Limited
        (“SS Media”, “We”, “Us”, or “Our”) governing your use of the SS Media
        mobile application (“App”), available on Google Play Store, Apple App
        Store, and other platforms.
      </p>

      <p>
        By installing, accessing, or using the App, You agree to be bound by
        this Agreement. If You do not agree, do not install or use the App.
      </p>

      {/* ---------------------- SECTION 1 ---------------------- */}
      <h2>1. LICENSE GRANT</h2>
      <p>SS Media grants You a limited, non-exclusive, non-transferable, revocable license to:</p>
      <ul>
        <li>Download, install, and use the App on a compatible mobile device.</li>
        <li>
          Access and use news articles, trending stories, and video content
          linked from SS Media’s official YouTube channel.
        </li>
        <li>
          Share content externally via supported social media or messaging
          platforms for personal, non-commercial purposes.
        </li>
      </ul>
      <p>This license is subject to compliance with all terms of this Agreement.</p>

      {/* ---------------------- SECTION 2 ---------------------- */}
      <h2>2. RESTRICTIONS</h2>
      <ul>
        <li>
          Copy, reproduce, republish, modify, or distribute App content without
          SS Media’s prior written consent.
        </li>
        <li>Use the App for commercial purposes, unauthorized advertising, or illegal activities.</li>
        <li>
          Reverse engineer, decompile, or attempt to extract the source code of
          the App.
        </li>
        <li>
          Remove, alter, or obscure any proprietary notices, including
          copyright, trademark, or other intellectual property notices.
        </li>
        <li>
          Circumvent any digital rights management, security features, or usage
          limitations of the App.
        </li>
        <li>Impersonate SS Media or any other individual/entity while using the App.</li>
      </ul>

      {/* ---------------------- SECTION 3 ---------------------- */}
      <h2>3. USER CONTENT AND ACCOUNTABILITY</h2>
      <p>News content is created, owned, and maintained by SS Media.</p>
      <p>Videos embedded in the App remain the property of SS Media’s official YouTube channel.</p>
      <p>Users may post comments under news or video content.</p>
      <p>
        Any user who posts objectionable, abusive, or unlawful comments shall be
        held accountable and may face suspension or termination of their
        account.
      </p>
      <p>
        Users can report any SS Media content or comments posted by other
        individuals using the Feedback option available in the Right Menu. SS
        Media will review all reports and take necessary action within 24 hours.
      </p>

      {/* ---------------------- SECTION 4 ---------------------- */}
      <h2>4. ZERO-TOLERANCE POLICY</h2>
      <p>
        SS Media enforces a strict zero-tolerance policy for objectionable
        content and abusive behavior.
      </p>
      <p>Objectionable content includes hate speech, harassment, explicit material, misinformation, or any content violating applicable laws.</p>
      <p>Reported content will be reviewed promptly, and offending accounts will be suspended or terminated.</p>

      {/* ---------------------- SECTION 5 ---------------------- */}
      <h2>5. INTELLECTUAL PROPERTY</h2>
      <p>
        All intellectual property rights in the App — including content, design,
        graphics, logos, and software — are owned by SS Media. This Agreement
        does not grant You any ownership or rights beyond the limited license
        specified herein. Unauthorized use of App content or intellectual
        property may result in legal action.
      </p>

      {/* ---------------------- SECTION 6 ---------------------- */}
      <h2>6. TERMINATION</h2>
      <p>
        SS Media may suspend or terminate your access to the App at any time for
        violation of this Agreement or applicable law.
      </p>
      <p>You may discontinue use by uninstalling the App at any time.</p>
      <p>
        Termination of this Agreement does not limit SS Media’s rights regarding
        your prior violations or use of App content.
      </p>

      {/* ---------------------- SECTION 7 ---------------------- */}
      <h2>7. DISCLAIMER OF WARRANTIES</h2>
      <p>
        The App is provided “as-is” and “as available”, without warranties of
        any kind, whether express or implied. SS Media does not guarantee
        uninterrupted, error-free, or secure access to the App. You acknowledge
        that any reliance on App content or videos is at your own risk.
      </p>

      {/* ---------------------- SECTION 8 ---------------------- */}
      <h2>8. LIMITATION OF LIABILITY</h2>
      <p>
        To the maximum extent permitted by law, SS Media shall not be liable for
        any indirect, incidental, or consequential damages arising from:
      </p>
      <ul>
        <li>Your access to or use of the App;</li>
        <li>Errors, omissions, or inaccuracies in App content;</li>
        <li>External video content or links;</li>
        <li>Any technical issues, interruptions, or device incompatibilities.</li>
      </ul>
      <p>Your sole remedy is to discontinue use of the App.</p>

      {/* ---------------------- SECTION 9 ---------------------- */}
      <h2>9. GOVERNING LAW AND JURISDICTION</h2>
      <p>
        This Agreement is governed by the laws of India. Any disputes arising
        under or in connection with this Agreement shall be subject to the
        exclusive jurisdiction of courts in Chennai, Tamil Nadu.
      </p>

      {/* ---------------------- SECTION 10 ---------------------- */}
      <h2>10. MODIFICATIONS</h2>
      <p>
        SS Media reserves the right to update or modify this Agreement at any
        time. Continued use of the App constitutes acceptance of any changes.
        The most recent version will be accessible within the App or on our
        website: https://ssmedia.app.
      </p>

      {/* ---------------------- SECTION 11 ---------------------- */}
      <h2>11. CONTACT INFORMATION</h2>
      <p>For questions or concerns regarding this EULA, please contact us through:</p>
      <p>📧 developercharlestech@gmail.com</p>
      <p>🏢 Charles Technologies Private Limited, Chennai, Tamil Nadu, India</p>

      <p className={styles.updated}>Last Updated: November 2025</p>
    </div>
  );
};

export default EULA;
